import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { campaignAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

const s = {
  page: { maxWidth: 1100, margin: '0 auto', padding: '3rem 2rem' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.5rem', flexWrap: 'wrap', gap: '1rem' },
  title: { fontFamily: 'Fraunces, serif', fontSize: '2rem', fontWeight: 600, color: '#1c1814' },
  btn: { background: '#c0392b', color: '#fff', border: 'none', borderRadius: 10, padding: '0.7rem 1.5rem', fontSize: '0.875rem', fontWeight: 600, cursor: 'pointer', textDecoration: 'none', display: 'inline-block' },
  card: { background: '#fff', border: '1px solid #e2dbd0', borderRadius: 16, padding: '1.5rem', marginBottom: '1.25rem' },
  campTitle: { fontWeight: 600, color: '#1c1814', marginBottom: '0.35rem' },
  campMeta: { fontSize: '0.8rem', color: '#7a6f65', marginBottom: '1rem' },
  progTrack: { background: '#f4f0e8', borderRadius: 100, height: 7, overflow: 'hidden', marginBottom: '0.4rem' },
  progFill: { height: '100%', background: 'linear-gradient(90deg,#1e6f3e,#27ae60)', borderRadius: 100 },
  status: { display: 'inline-block', fontSize: '0.72rem', padding: '3px 10px', borderRadius: 100, fontWeight: 600 },
  empty: { textAlign: 'center', padding: '3rem', color: '#7a6f65' },
};

const statusStyle = { APPROVED: { background: '#edf7f2', color: '#1e6f3e' }, PENDING: { background: '#fdf6e8', color: '#c8962a' }, REJECTED: { background: '#fdf0ee', color: '#c0392b' }, FUNDED: { background: '#e8eaf5', color: '#2d4fa4' }, CLOSED: { background: '#f4f0e8', color: '#7a6f65' } };

export function Dashboard() {
  const { user } = useAuth();
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    campaignAPI.getMyCampaigns().then(({ data }) => setCampaigns(data.content || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Welcome, {user?.fullName?.split(' ')[0]}!</h1>
          <p style={{ color: '#7a6f65', marginTop: '0.25rem' }}>Manage your campaigns below.</p>
        </div>
        <Link to="/create-campaign" style={s.btn}>+ Start new campaign</Link>
      </div>

      {loading && <div style={s.empty}>Loading your campaigns...</div>}
      {!loading && campaigns.length === 0 && (
        <div style={s.empty}>
          <p style={{ marginBottom: '1rem' }}>You haven't created any campaigns yet.</p>
          <Link to="/create-campaign" style={s.btn}>Start your first campaign →</Link>
        </div>
      )}
      {campaigns.map(c => {
        const pct = Math.min(c.progressPercent, 100);
        return (
          <div key={c.id} style={s.card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '0.5rem' }}>
              <div>
                <div style={s.campTitle}>{c.title}</div>
                <div style={s.campMeta}>{c.formerRole} · {c.formerCompany} · Created {new Date(c.createdAt).toLocaleDateString()}</div>
              </div>
              <span style={{ ...s.status, ...statusStyle[c.status] }}>{c.status}</span>
            </div>
            <div style={s.progTrack}><div style={{ ...s.progFill, width: `${pct}%` }} /></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', color: '#7a6f65' }}>
              <span>{c.currency} {c.raisedAmount?.toLocaleString()} raised</span>
              <span>{pct}% of {c.currency} {c.goalAmount?.toLocaleString()}</span>
            </div>
            <div style={{ marginTop: '1rem' }}>
              <Link to={`/campaigns/${c.id}`} style={{ fontSize: '0.82rem', color: '#c0392b', fontWeight: 600, marginRight: '1.5rem' }}>View campaign →</Link>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function AdminPanel() {
  return (
    <div style={s.page}>
      <h1 style={s.title}>Admin Panel</h1>
      <p style={{ color: '#7a6f65', marginBottom: '2rem' }}>Review and approve pending campaigns.</p>
      <div style={{ background: '#fdf6e8', border: '1px solid rgba(200,150,42,0.2)', borderRadius: 12, padding: '1.5rem', color: '#7a6f65' }}>
        Full admin panel coming in next release. Use the API endpoints directly for now:<br /><br />
        <code style={{ background: '#fff', padding: '4px 8px', borderRadius: 6, fontSize: '0.82rem' }}>GET /api/admin/campaigns/pending</code><br /><br />
        <code style={{ background: '#fff', padding: '4px 8px', borderRadius: 6, fontSize: '0.82rem' }}>POST /api/admin/campaigns/:id/approve</code>
      </div>
    </div>
  );
}

export function NotFound() {
  return (
    <div style={{ ...s.page, textAlign: 'center', padding: '6rem 2rem' }}>
      <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: '4rem', color: '#e2dbd0', marginBottom: '1rem' }}>404</h1>
      <p style={{ color: '#7a6f65', marginBottom: '2rem' }}>Page not found.</p>
      <Link to="/" style={s.btn}>Go home →</Link>
    </div>
  );
}

export default Dashboard;
